import { IAuthToken } from '../constants/interfaces';
import { Helpers } from './Helpers';

const AUTH_TOKEN_STORAGE_NAME = 'auth-token';
const MFA_REMEMBER_STORAGE_NAME = 'mfa-remember-token';

export class StorageService {
  static getAuthToken = (): IAuthToken | null => {
    const token = localStorage.getItem(AUTH_TOKEN_STORAGE_NAME);
    return Helpers.decodeAuthToken(token);
  };
  static setAuthToken = (token: string): void => {
    localStorage.setItem(AUTH_TOKEN_STORAGE_NAME, token);
  };
  static getMfaRememberMe = (userName: string): string => {
    return localStorage.getItem(`${MFA_REMEMBER_STORAGE_NAME}-${userName.trim()}`) ?? '';
  };
  static setMfaRememberMe = (userName: string, token: string): void => {
    localStorage.setItem(`${MFA_REMEMBER_STORAGE_NAME}-${userName.trim()}`, token);
  };
  static clearMfaRememberMe = (): void => {
    localStorage.removeItem(MFA_REMEMBER_STORAGE_NAME);
  };
}
